var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { on: { click: _vm.onIconClick } },
    [
      _vm.disabled
        ? [
            _c(
              "span",
              {
                staticClass: "icon",
                style: {
                  width: `${_vm.size}px`,
                  height: `${_vm.size}px`,
                  backgroundColor: _vm.backgroundColor,
                  borderRadius: {
                    squire: `${(_vm.size - 0) / 6}px`,
                    circle: "50%",
                  }[_vm.shape],
                },
              },
              [
                _vm._t("icon", function () {
                  return [
                    _vm.yellowIcon
                      ? _c("img", {
                          staticClass: "icon-img",
                          style: {
                            width: `${_vm.iconSize}px`,
                            height: `${_vm.iconSize}px`,
                          },
                          attrs: { src: _vm.GuidanceIconYellow },
                        })
                      : _c("img", {
                          staticClass: "icon-img",
                          style: {
                            width: `${_vm.iconSize}px`,
                            height: `${_vm.iconSize}px`,
                          },
                          attrs: { src: _vm.GuidanceIcon },
                        }),
                  ]
                }),
              ],
              2
            ),
          ]
        : [
            _c(
              "el-tooltip",
              {
                staticClass: "guidance-tooltip-container",
                attrs: { effect: "light", placement: _vm.placement },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "icon",
                    style: {
                      width: `${_vm.size}px`,
                      height: `${_vm.size}px`,
                      backgroundColor: _vm.backgroundColor,
                      borderRadius: {
                        squire: `${(_vm.size - 0) / 6}px`,
                        circle: "50%",
                      }[_vm.shape],
                    },
                  },
                  [
                    _vm._t("icon", function () {
                      return [
                        _vm.yellowIcon
                          ? _c("img", {
                              staticClass: "icon-img",
                              style: {
                                width: `${_vm.iconSize}px`,
                                height: `${_vm.iconSize}px`,
                              },
                              attrs: { src: _vm.GuidanceIconYellow },
                            })
                          : _c("img", {
                              staticClass: "icon-img",
                              style: {
                                width: `${_vm.iconSize}px`,
                                height: `${_vm.iconSize}px`,
                              },
                              attrs: { src: _vm.GuidanceIcon },
                            }),
                      ]
                    }),
                  ],
                  2
                ),
                _c("div", {
                  staticClass: "content",
                  style: { fontSize: `${_vm.fontSize}px` },
                  attrs: { slot: "content" },
                  domProps: { innerHTML: _vm._s(_vm.content) },
                  slot: "content",
                }),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }